import "./App.css";
import styles from "./App.module.css";
import Banner from "./components/banner/banner";
import LazyLoad from "react-lazyload";
import Judge from "./components/judge/judge";
import Enter from "./components/enter/enter";
import Submit from "./components/submit/submit";
import { useEffect, useState } from "react";
import Period from "./components/period/period";
import Prize from "./components/prize/prize";
import AboutM3 from "./components/aboutM3/aboutM3";


function App() {
  const [resources, setResources] = useState(
    "https://bucket.zhiyun-tech.com/detail/"
  );

  return (
    <div className="m3-active-ctn">
      <a href="https://explore.zhiyun-tech.com/en/club/project/detail/21975010642104320" className={styles.windowlinkBox}>
        <LazyLoad className={styles.windowlink}>
          <img src={`${resources}m3challenge-windowlink.png`} alt="" className="m3-active-desktop"/>
          <img src={`${resources}m3challenge-windowlink-mobile.png`} alt="" className="m3-active-mobile"/>
        </LazyLoad>
      </a>

      <Banner resources={resources} />
      <Judge resources={resources} />
      <Enter resources={resources} />
      <Submit resources={resources} />
      <Period resources={resources} />
      <Prize resources={resources} />
      <AboutM3 resources={resources} />
    </div>
  );
}

export default App;
